module.exports = __webpack_public_path__ + "static/media/ms-happy-fruit.3da5da8e.jpg";